import { NAV_BREAKPOINT_PX, WIDE_BREAKPOINT_PX } from '@shared/constants/layout';

import { useMediaQuery } from './useMediaQuery';

/**
 * The three viewport bands the UI distinguishes. `phone` is below the nav
 * breakpoint (no sidebar, no tab strip, bottom bar); `desktop` has the sidebar
 * but a single content column; `wide` has room for three panels.
 */
export type Viewport = 'phone' | 'desktop' | 'wide';

/** The media query for "at or above" a breakpoint — the one string tests may stub. */
export function minWidthQuery(px: number): string {
  return `(min-width: ${px}px)`;
}

/**
 * Which viewport band the window is in right now, live.
 *
 * The single home for "is this a phone?" — consumers compare against a word,
 * never a pixel. `wide` wins when its query matches regardless of the nav
 * query, so a test that stubs only one string still reads sensibly.
 */
export function useViewport(): Viewport {
  const atLeastNav = useMediaQuery(minWidthQuery(NAV_BREAKPOINT_PX));
  const atLeastWide = useMediaQuery(minWidthQuery(WIDE_BREAKPOINT_PX));
  if (atLeastWide) return 'wide';
  if (atLeastNav) return 'desktop';
  return 'phone';
}
